import { render, staticRenderFns } from "./EditMetas.vue?vue&type=template&id=410dae51&scoped=true&"
import script from "./EditMetas.vue?vue&type=script&lang=ts&"
export * from "./EditMetas.vue?vue&type=script&lang=ts&"
import style0 from "./EditMetas.vue?vue&type=style&index=0&id=410dae51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410dae51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
